// File: src/pages/Invoices/InvoiceForm.jsx
// فوق: import …  
// -------------------------
 const initialFormState = {
  invoiceTypeId: 0,     // سيُعاد ضبطه لاحقاً إلى initialType
  invoiceNumber: "",
  issueDate: new Date().toISOString().slice(0, 16),
  referenceNumber: "-1",
  referenceDate: new Date().toISOString().slice(0, 16),
  supplierId: 0,
  customerPrevBalance: 0,
  stockId: 0,
  salesmanId: null,
  paymentMethodId: 0,
  safeId: 0,
  bankId: 0,
  notes: "",
  discount: 0,
  invoiceStatus: 0,
  lines: [],
};
// -------------------------

import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../axios"; // تأكد من المسار الصحيح لـ axios
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { SettingsContext } from "../../contexts/SettingsContext"; // تأكد من المسار الصحيح للـ Context
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function InvoiceForm({ viewMode }) {
  const navigate = useNavigate();
  const { id, typeId } = useParams();
const [editingId, setEditingId] = useState(id ?? null);
  const initialType = typeId ? parseInt(typeId, 10) : 0;

  const companyId = parseInt(localStorage.getItem("companyId"), 10);
  const branchId = parseInt(localStorage.getItem("branchId"), 10);
  
  // Security Context
  const restrictedSafeId = localStorage.getItem("safeId") ? parseInt(localStorage.getItem("safeId"), 10) : null;
  const restrictedStockId = localStorage.getItem("stockId") ? parseInt(localStorage.getItem("stockId"), 10) : null;
  
  // Multi-context support
  const allowedSafeIds = localStorage.getItem("allowedSafeIds") ? JSON.parse(localStorage.getItem("allowedSafeIds")) : [];
  const allowedStockIds = localStorage.getItem("allowedStockIds") ? JSON.parse(localStorage.getItem("allowedStockIds")) : [];

  const [productSearch, setProductSearch] = useState("");

  const [showApproveButton, setShowApproveButton] = useState(false);
const [isApproved, setIsApproved] = useState(false);
const [isSaving, setIsSaving] = useState(false);
const [canUnapprove, setCanUnapprove] = useState(false);
const [isZatcaLocked, setIsZatcaLocked] = useState(false);
  // جلب decimalPlaces من SettingsContext
  const { decimalPlaces } = useContext(SettingsContext);
  // قيمة الخطوة لحقول الأرقام، تعتمد على عدد الأرقام العشرية
  const stepValue = 1 / 10 ** decimalPlaces;

  // lookup lists (قوائم البحث)
  const [types, setTypes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [methods, setMethods] = useState([]);
  const [safes, setSafes] = useState([]);
  const [banks, setBanks] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [products, setProducts] = useState([]);

  // program settings state (حالة إعدادات البرنامج)
  const [settings, setSettings] = useState({
    isPriceIncludesVAT: false, // قيمة افتراضية للحماية، ستُستبدل من Context/API
    autoApproveInvoices: false,
    autoPrintAfterSave: false,
    allowNegativeSales: false,
    pricingPolicy: "",
    decimalPlaces: 2, // قيمة افتراضية للحماية، ستُستبدل من Context/API
  });

  // النموذج (Form state)
  const [form, setForm] = useState({
    invoiceTypeId: initialType,
    invoiceNumber: "",
    issueDate: new Date().toISOString().slice(0, 16),
    referenceNumber: "-1",
    referenceDate: new Date().toISOString().slice(0, 16),
    supplierId: 0,
    customerPrevBalance: 0,
    stockId: 0,
    salesmanId: null,
    paymentMethodId: 0,
    safeId: 0,
    bankId: 0,
    notes: "",
    discount: 0, // خصم الفاتورة الإجمالي
    invoiceStatus: 0, // 0: مسودة, 1: معتمدة, 2: مدفوعة
    lines: [], // سطور الفاتورة
    journalEntryGlobalId: null, // ✅ Add this
  });

  // 1. جلب القوائم الأساسية و—إن كان تعديل—جلب بيانات الفاتورة
  useEffect(() => {
    if (!companyId) return;

    axios
      .get(`/InvoiceTypes?companyId=${companyId}`)
      .then((r) => setTypes(r.data))
      .catch(console.error);

    axios
      .get(`/supplier/by-company/${companyId}`)
      .then((r) => setCustomers(r.data))
      .catch(console.error);

    axios
      .get(`/PaymentMethod/by-company/${companyId}`)
      .then((r) => setMethods(r.data))
      .catch(console.error);

    axios
      .get(`/Safe/by-company/${companyId}`)
      .then((r) => setSafes(r.data))
      .catch(console.error);

    axios
      .get(`/Bank/by-company/${companyId}`)
      .then((r) => setBanks(r.data))
      .catch(console.error);

    axios
      .get(`/Stock/by-company/${companyId}`)
      .then((r) => setStocks(r.data))
      .catch(console.error);

    axios
      .get(`/Product/by-company/${companyId}`)
      .then((r) => setProducts(r.data))
      .catch(console.error);
    // إذا كان تعديل، جلب بيانات الفاتورة الموجودة
    if (editingId) {
      axios
        .get(`/Invoice/${editingId}`)
        .then((r) => {
          const d = r.data;
          setForm({
            invoiceTypeId: d.invoiceType,
            invGlobalID: d.invGlobalID,
            invoiceNumber: d.invoiceNumber,
            issueDate: d.issueDate.slice(0, 16),
            referenceNumber: d.referenceNumber ?? "-1",
            referenceDate: (d.referenceDate ?? d.issueDate).slice(0, 16),
            supplierId: d.supplierId ?? 0,
            customerPrevBalance: parseFloat(d.customerPrevBalance ?? 0), // تحويل لرقم
            stockId: d.stockId,
            salesmanId: d.salesmanId ?? null,
            paymentMethodId: d.paymentMethodId,
            safeId: d.safeId ?? 0,
            bankId: d.bankId ?? 0,
            notes: d.notes ?? "",
            discount: parseFloat(d.discountTotal ?? 0).toFixed(decimalPlaces), // تنسيق خصم الفاتورة عند الجلب
            invoiceStatus: d.invoiceStatus ?? 0,
            journalEntryGlobalId: d.journalEntryGlobalId, // ✅ Populate from API
            // عند جلب الفاتورة للتعديل/العرض، يجب أن تتوافق الأسعار مع إعدادات الضريبة الحالية
            lines: (d.items || []).map((it) => {
              const unitPriceFromApi = it.unitPrice; // هذا هو السعر بدون ضريبة من API
              const taxRateFromApi = it.taxPercent;
              let displayPrice = unitPriceFromApi;

            setIsApproved(d.invoiceStatus === 1);
            setCanUnapprove(!!d.canUnapprove);
            setIsZatcaLocked(!!d.isZatcaLocked);

              // 💡 تصحيح: إذا كان السعر يجب أن يشمل الضريبة للعرض، نضيف الضريبة على السعر الأساسي
              if (settings.isPriceIncludesVAT) {
                displayPrice = unitPriceFromApi * (1 + taxRateFromApi);
              }

              return {
                productId: it.productId,
                productName: it.description,
                unitId: it.unitId,
                unitName: it.unitName || "",
                qty: parseFloat(it.quantity).toFixed(decimalPlaces),
                price: parseFloat(displayPrice).toFixed(decimalPlaces), // تنسيق السعر عند الجلب
                discount: parseFloat(it.discount).toFixed(decimalPlaces),
                taxRate: parseFloat(it.taxPercent).toFixed(decimalPlaces),
                unitsList: it.units || [],
                
              };
            }),
          });
        })
        .catch(console.error);
    }
  }, [companyId, editingId, settings.isPriceIncludesVAT, decimalPlaces]); // إضافة decimalPlaces كـ dependency مهم هنا

  // داخل مكوّن InvoiceForm، قبل أي useEffect
const fetchNextInvoiceNumber = async (typeId) => {
  // إذا لم يتم تمرير نوع صحيح، لا نفعل شيئاً
  if (!typeId || editingId) return;

  try {
    const res = await axios.get(
      `/Invoice/next-number/${companyId}/${branchId}/${typeId}`
    );
    setForm(f => ({
      ...f,
      invoiceNumber: res.data.toString(),
      // نعيد تعيين التواريخ عند الحصول على رقم جديد
      issueDate: new Date().toISOString().slice(0, 16),
      referenceDate: new Date().toISOString().slice(0, 16),
    }));
  } catch (error) {
    console.error("❌ فشل جلب رقم الفاتورة التالي:", error);
  }
};

  // 2. جلب رقم الفاتورة التالي للنموذج الجديد
  useEffect(() => {
  // نستدعي دائماً الدالة عند التحميل أو تغيير النوع
  fetchNextInvoiceNumber(form.invoiceTypeId);
}, [
  companyId,
  branchId,
  form.invoiceTypeId,   // سيعيد الاستدعاء إذا تغيّر النوع
  editingId,
  viewMode,
]);

  // 3. جلب الإعدادات الافتراضية وتطبيقها (فقط للفاتورة الجديدة)
    useEffect(() => {
    if (editingId) return; // لا تسرق القيم عند التعديل، فقط للفواتير الجديدة
    if (!companyId || !form.invoiceTypeId || methods.length === 0) return; // تأكد أن methods قد تم جلبها

    axios
      .get("/ProgramSettings/by-company-and-type", {
        params: { companyId, invoiceTypeId: form.invoiceTypeId },
      })
      .then((r) => {
        const s = r.data;
        const cashMethod = methods.find((m) => m.nameAr === "نقدي");
        const cashId = cashMethod ? cashMethod.id : null;

        // Priority: Restricted Single > Settings > Default
        // New Logic: Check lists
        let finalSafeId = s.defaultSafeId || 0;
        if (restrictedSafeId) {
            finalSafeId = restrictedSafeId;
        } else if (allowedSafeIds.length > 0) {
            if (!allowedSafeIds.includes(finalSafeId)) {
                finalSafeId = allowedSafeIds[0];
            }
        }

        let finalStockId = s.defaultStockId || 0;
        if (restrictedStockId) {
            finalStockId = restrictedStockId;
        } else if (allowedStockIds.length > 0) {
            if (!allowedStockIds.includes(finalStockId)) {
                finalStockId = allowedStockIds[0];
            }
        }

        setForm((f) => ({
          ...f,
          supplierId: s.defaultsupplierId ?? f.supplierId,
          paymentMethodId: s.defaultPaymentMethodId ?? f.paymentMethodId,
          // إذا طريقة الدفع نقدي املأ safeId، وإلا املأ bankId
          safeId:
            (s.defaultPaymentMethodId ?? f.paymentMethodId) === cashId
              ? finalSafeId
              : 0, // Reset if not cash
          bankId:
            (s.defaultPaymentMethodId ?? f.paymentMethodId) !== cashId
              ? s.defaultBankId ?? f.bankId
              : 0, // Reset if cash
          stockId: finalStockId,
          invoiceStatus: s.autoApproveInvoices ? 1 : 0,
        }));
        setSettings(s); // حفظ إعدادات البرنامج
      })
      .catch(() => {
        // If settings fail, still apply restrictions if present
        let forcedStockId = form.stockId;
        if (restrictedStockId) forcedStockId = restrictedStockId;
        else if (allowedStockIds.length > 0 && !allowedStockIds.includes(form.stockId)) forcedStockId = allowedStockIds[0];

        let forcedSafeId = form.safeId;
        if (restrictedSafeId) forcedSafeId = restrictedSafeId;
        else if (allowedSafeIds.length > 0 && !allowedSafeIds.includes(form.safeId)) forcedSafeId = allowedSafeIds[0];

        if (forcedStockId !== form.stockId || forcedSafeId !== form.safeId) {
             setForm(f => ({
                 ...f,
                 safeId: forcedSafeId,
                 stockId: forcedStockId
             }));
        }
      });
  }, [companyId, form.invoiceTypeId, editingId, methods, restrictedSafeId, restrictedStockId]); // أضف methods كـ dependency
  // —————————— Handlers (معالجات الأحداث) ——————————

  function handleChange(e) {
    const { name, value } = e.target;
    let newValue = value;

    if (
      [
        "paymentMethodId",
        "safeId",
        "bankId",
        "supplierId",
        "stockId",
        "salesmanId",
        "invoiceStatus",
      ].includes(name)
    ) {
      newValue = +value; // تحويل إلى رقم
    } else if (name === "discount") {
      // تنسيق خصم الفاتورة الإجمالي ليظل بعدد الأرقام العشرية المحددة
      newValue = parseFloat(value).toFixed(decimalPlaces);
    }

    setForm((f) => ({ ...f, [name]: newValue }));
  }

  function handleAddLine() {
    setForm((f) => ({
      ...f,
      lines: [
        ...f.lines,
        {
          productId: 0,
          productName: "",
          unitId: 0,
          unitName: "",
          qty: parseFloat(1).toFixed(decimalPlaces), // تنسيق الكمية الافتراضية
          price: parseFloat(0).toFixed(decimalPlaces), // تنسيق السعر الافتراضي
          discount: parseFloat(0).toFixed(decimalPlaces), // تنسيق الخصم الافتراضي للسطر
          taxRate: parseFloat(0).toFixed(decimalPlaces), // تنسيق الضريبة الافتراضية للسطر
          unitsList: [],
        },
      ],
    }));
  }

  function handleRemoveLine(i) {
    setForm((f) => ({ ...f, lines: f.lines.filter((_, j) => j !== i) }));
  }

  const handleLineChange = async (idx, field, raw) => {
  const lines = [...form.lines];
  const ln = lines[idx];

  if (field === "productName") {
  ln.productName = raw;
  const p = products.find((x) => x.arabicName === raw);
  if (!p) {
    lines[idx] = ln;
    setForm((f) => ({ ...f, lines }));
    return;
  }
    ln.productId = p.id;
    ln.productName = p.arabicName;
    ln.taxRate = parseFloat(p.taxRate).toFixed(decimalPlaces);
    ln.unitsList = p.units || [];
    const bu = ln.unitsList.find((u) => u.isBaseUnit) || {};
    ln.unitId = bu.unitId || 0;
    ln.unitName = bu.unitNameAr || "";
    let newPrice = bu.purchprice ?? p.purchprice ?? 0;
    if (settings.isPriceIncludesVAT) {
      newPrice *= 1 + parseFloat(ln.taxRate);
    }
    ln.price = parseFloat(newPrice).toFixed(decimalPlaces);
    ln.discount = parseFloat(0).toFixed(decimalPlaces);
    ln.qty = parseFloat(1).toFixed(decimalPlaces);
  }

  else if (field === "unitId") {
    const u = ln.unitsList.find((x) => x.unitId === +raw) || {};
    ln.unitId = u.unitId || 0;
    ln.unitName = u.unitNameAr || "";
    // إصلاح: استخدام purchprice للمشتريات بدلاً من salprice
    let price = u.purchprice ?? 0;
    if (settings.isPriceIncludesVAT) {
      price *= 1 + parseFloat(ln.taxRate);
    }
    ln.price = parseFloat(price).toFixed(decimalPlaces);
  }

  else if (field === "qty") {
    ln.qty = parseFloat(raw).toFixed(decimalPlaces);
  }

  else if (field === "price") {
    ln.price = parseFloat(raw).toFixed(decimalPlaces);
  }

  else if (field === "discount") {
    ln.discount = parseFloat(raw).toFixed(decimalPlaces);
  }

  lines[idx] = ln;
  setForm((f) => ({ ...f, lines }));
};


  // —————— حساب المجاميع ——————
  const calculateTotals = () => {
    let subtotalVisible = 0; // المجموع الكلي للسطور (كمية * سعر مدخل). هذا هو ما يراه العميل كـ "مجموع".
    let totalLineDiscounts = 0; // مجموع الخصومات المطبقة على السطور

    // المجاميع الداخلية لحساب الضريبة والصافي الحقيقي بعد خصم الضريبة
    let totalTaxableAmount = 0; // مجموع القيم الخاضعة للضريبة لكل سطر (بعد خصم السطر)
    let totalVATCalculated = 0; // مجموع الضريبة المحسوبة من كل سطر

    form.lines.forEach((ln) => {
      const qty = parseFloat(ln.qty);
      const price = parseFloat(ln.price); // السعر المدخل (شامل أو غير شامل للضريبة)
      const discount = parseFloat(ln.discount); // خصم السطر
      const taxRate = parseFloat(ln.taxRate);

      let lineTotalBeforeDiscountInvoiced = qty * price; // مجموع السطر بالأسعار المعروضة (السعر المدخل * الكمية)
      let lineTotalAfterLineDiscountInvoiced = lineTotalBeforeDiscountInvoiced - discount; // مجموع السطر بعد خصم السطر، بالأسعار المعروضة

      subtotalVisible += lineTotalBeforeDiscountInvoiced; // هذا هو "المجموع" الذي يظهر في التلخيص
      totalLineDiscounts += discount;

      let taxableAmountPerLine = lineTotalAfterLineDiscountInvoiced; // القيمة التي سنحسب عليها الضريبة
      let vatAmountPerLine = 0;

      // 💡 النقطة الحرجة: إذا كان السعر يشمل الضريبة، نحتاج إلى "تفكيك" الضريبة من القيمة
      if (settings.isPriceIncludesVAT) {
        taxableAmountPerLine = lineTotalAfterLineDiscountInvoiced / (1 + taxRate);
        vatAmountPerLine = lineTotalAfterLineDiscountInvoiced - taxableAmountPerLine;
      } else {
        // إذا كان السعر لا يشمل الضريبة، فإن القيمة الخاضعة للضريبة هي نفسها بعد الخصم
        vatAmountPerLine = lineTotalAfterLineDiscountInvoiced * taxRate;
      }

      totalTaxableAmount += taxableAmountPerLine;
      totalVATCalculated += vatAmountPerLine;
    });

    const totalDocumentDiscount = parseFloat(form.discount); // خصم الفاتورة الإجمالي

    // خصم الفاتورة الإجمالي يطبق على 'totalTaxableAmount' (المجموع الفرعي الخاضع للضريبة)
    const finalTaxableAmountAfterDocDiscount = totalTaxableAmount - totalDocumentDiscount;

    // الصافي النهائي هو مجموع القيم الخاضعة للضريبة بعد كل الخصومات + مجموع الضرائب
    const net = finalTaxableAmountAfterDocDiscount + totalVATCalculated;

    return {
      subtotal: subtotalVisible, // المجموع الكلي للسطور بناءً على السعر المدخل (شامل للضريبة أو لا)
      totalDiscount: totalDocumentDiscount, // خصم الفاتورة المدخل فقط
      totalAfterDiscount: finalTaxableAmountAfterDocDiscount, // المجموع بعد خصم السطر وخصم الفاتورة، لكنه "المبلغ الخاضع للضريبة"
      totalVAT: totalVATCalculated, // إجمالي الضريبة المحسوبة
      net: net, // الصافي النهائي
    };
  };

  const totals = calculateTotals();

  // —————— الحفظ ——————
  async function handleSubmit(e) {
    e.preventDefault();
    if (viewMode || isSaving) return;
    // تحقق من الصندوق / البنك
    const cashMethod = methods.find((m) => m.nameAr === "نقدي")?.id;
    if (form.paymentMethodId === cashId && !form.safeId)
      return alert("اختر صندوقاً");
    if (form.paymentMethodId !== cashId && !form.bankId)
      return alert("اختر بنكاً");

    const payloadItems = form.lines.map((ln) => {
      // تحويل القيم إلى أرقام قبل معالجتها لإرسالها للـ API
      const qty = parseFloat(ln.qty);
      const price = parseFloat(ln.price); // السعر المدخل في الواجهة
      const discount = parseFloat(ln.discount);
      const taxRate = parseFloat(ln.taxRate);

      let unitPriceForAPI = price;
      // 💡 النقطة الحرجة: إذا كان السعر في الواجهة يشمل الضريبة، يجب إرسال السعر الأساسي (بدون ضريبة) للـ API.
      // الـ API يتوقع دائماً unitPrice بدون ضريبة.
      if (settings.isPriceIncludesVAT) {
        unitPriceForAPI = price / (1 + taxRate);
      }
      return {
        productId: ln.productId,
        unitId: ln.unitId,
        quantity: qty,
        unitPrice: unitPriceForAPI, // إرسال السعر بدون ضريبة للـ API
        discount: discount,
        taxPercent: taxRate,
      };
    });

    let invoiceStatusToSend = form.invoiceStatus; // ابدأ بالقيمة الحالية من الـ UI
    if (!editingId && settings.autoApproveInvoices) { // إذا كانت فاتورة جديدة والإعداد مفعل
        invoiceStatusToSend = 1; // اجعلها معتمدة في الـ payload فقط
    }

    const payload = {
      companyId,
      branchId,
      invoiceTypeId: form.invoiceTypeId,
      invoiceNumber: form.invoiceNumber,
      issueDate: form.issueDate,
      referenceNumber: form.referenceNumber,
      referenceDate: form.referenceDate,
      supplierId: form.supplierId,
      customerPrevBalance: parseFloat(form.customerPrevBalance), // إرسال كـ رقم
      stockId: form.stockId,
      salesmanId: form.salesmanId,
      paymentMethodId: form.paymentMethodId,
      safeId: form.safeId,
      bankId: form.bankId,
      notes: form.notes,
      discount: parseFloat(form.discount), // إرسال خصم الفاتورة كـ رقم
      invoiceStatus: invoiceStatusToSend,
      totals: {
        // هذه المجاميع ترسل للـ API، يجب أن تعكس الأرقام النهائية بعد كل الحسابات
        subtotal: totals.subtotal, // المجموع الظاهر (كمية * سعر مدخل)
        totalAfterDiscount: totals.totalAfterDiscount, // القيمة الخاضعة للضريبة بعد كل الخصومات
        totalVAT: totals.totalVAT, // إجمالي الضريبة المحسوبة
        net: totals.net, // الصافي النهائي
      },
      items: payloadItems,
    };

    if (editingId) {
      payload.InvGlobalID = editingId;
    }

 const lines = [...form.lines];
  let hasError = false;

  // التحقق من الكميات والتكرار
  const productIds = new Set();
  for (let line of lines) {
    const qty = parseFloat(line.qty);
    if (!line.productId || isNaN(qty) || qty <= 0) {
      toast.error(`❌ الكمية غير صالحة للصنف "${line.productName}"`);
      return;
    }

    if (productIds.has(line.productId)) {
      toast.error(`❌ الصنف "${line.productName}" مكرر في الفاتورة.`);
      return;
    }
    productIds.add(line.productId);
  }
    try {
    setIsSaving(true);
    let response;
    if (editingId) {
      response = await axios.put(`/Invoice/${editingId}`, payload);
    } else {
      response = await axios.post(`/Invoice`, payload);
    }

const invGlobalId = response.data.invGlobalID;
const isApprovedAfterSave = invoiceStatusToSend === 1;
setShowApproveButton(!isApprovedAfterSave);
setIsApproved(isApprovedAfterSave);
setIsSaving(false);
Swal.fire({
  title: "✅ تم حفظ الفاتورة",
  showCancelButton: true,
  showDenyButton: !isApprovedAfterSave,
  cancelButtonText: "🆕 جديد", 
  confirmButtonText: "🖨️ طباعة",
  denyButtonText: !isApprovedAfterSave ? "📄 استمرار" : undefined,
}).then((result) => {
  if (result.isConfirmed) {
    window.open(`/invoices/print/${invGlobalId}`, "_blank");
  } else if (result.isDenied) {
    // تحميل الفاتورة في نفس الصفحة واعرض زر "اعتماد"
    fetchInvoiceById(invGlobalId);
    setShowApproveButton(true);
  } else {
resetForm();
  }
});


  } catch (err) {
    setIsSaving(false);
    console.error("Validation error:", err.response?.data || err);
    toast.error("❌ حدث خطأ أثناء الحفظ: " + JSON.stringify(err.response?.data?.errors || err));
  }
    
  }
const fetchInvoiceById = async (invGlobalId) => {
  try {
    const resp = await axios.get(`/Invoice/${invGlobalId}`);
    const invoiceData = resp.data;
    // حدّث الـ form والـ states
    setForm({
      // إذا كان هيكل الـ DTO مختلف، فكّر بتحويل الحقول هنا
      invoiceTypeId: invoiceData.invoiceType,
      invoiceNumber: invoiceData.invoiceNumber,
      issueDate: invoiceData.issueDate.slice(0, 16),
      referenceNumber: invoiceData.referenceNumber,
      referenceDate: invoiceData.referenceDate.slice(0, 16),
      supplierId: invoiceData.supplierId,
      customerPrevBalance: parseFloat(invoiceData.customerPrevBalance),
      stockId: invoiceData.stockId,
      salesmanId: invoiceData.salesmanId,
      paymentMethodId: invoiceData.paymentMethodId,
      safeId: invoiceData.safeId ?? 0,
      bankId: invoiceData.bankId ?? 0,
      notes: invoiceData.notes,
      discount: parseFloat(invoiceData.discountTotal).toFixed(decimalPlaces),
      invoiceStatus: invoiceData.invoiceStatus,
      lines: invoiceData.items.map((it) => ({
        productId: it.productId,
        productName: it.description,
        unitId: it.unitId,
        qty: parseFloat(it.quantity).toFixed(decimalPlaces),
        price: parseFloat(it.unitPrice * (settings.isPriceIncludesVAT ? 1 + it.taxPercent : 1)).toFixed(decimalPlaces),
        discount: parseFloat(it.discount).toFixed(decimalPlaces),
        taxRate: parseFloat(it.taxPercent).toFixed(decimalPlaces),
        unitsList: it.units || []
      }))
    });
    setShowApproveButton(invoiceData.invoiceStatus !== 1);
    setIsApproved(invoiceData.invoiceStatus === 1);
    setCanUnapprove(!!invoiceData.canUnapprove);
    setIsZatcaLocked(!!invoiceData.isZatcaLocked);
    setEditingId(invGlobalId);
  } catch (err) {
    console.error("❌ فشل تحميل الفاتورة", err);
    toast.error("❌ فشل تحميل الفاتورة");
  }
};


const handleApprove = async () => {
  try {
    setIsSaving(true);
    await axios.post(`/Invoice/approve/${form.invGlobalID}`);
    toast.success("✅ تم اعتماد الفاتورة وتحريك المخزون");
    setShowApproveButton(false);
    setCanUnapprove(!isZatcaLocked);
    setIsApproved(true);
    setForm((f) => ({ ...f, invoiceStatus: 1 }));
  } catch (err) {
    console.error(err);
    toast.error("❌ فشل في اعتماد الفاتورة");
  } finally {
    setIsSaving(false);
  }
};

const handleUnapprove = async () => {
  if (!form.invGlobalID || isSaving || !canUnapprove) return;

  const result = await Swal.fire({
    title: "إلغاء اعتماد الفاتورة؟",
    text: "سيتم إرجاع الفاتورة إلى مسودة حتى تتمكن من تعديلها.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "نعم، إلغاء الاعتماد",
    cancelButtonText: "إلغاء",
  });

  if (!result.isConfirmed) return;

  try {
    setIsSaving(true);
    await axios.post(`/Invoice/unapprove/${form.invGlobalID}`);
    await fetchInvoiceById(form.invGlobalID);
    toast.success("✅ تم إلغاء اعتماد الفاتورة وإرجاعها إلى مسودة");
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data || "❌ فشل إلغاء اعتماد الفاتورة");
  } finally {
    setIsSaving(false);
  }
};

const resetForm = () => {
    const type = form.invoiceTypeId || initialType;
  setEditingId(null);
    setForm({
      ...initialFormState,
      invoiceTypeId: type,
      invoiceStatus: settings.autoApproveInvoices ? 1 : 0
    });
    fetchNextInvoiceNumber(type);
    setShowApproveButton(false);
    setIsApproved(false);
    setCanUnapprove(false);
    setIsZatcaLocked(false);
  };
  // لمعرفة إذا الدفع نقدي أم لا
  const cashMethod = methods.find((m) => m.nameAr === "نقدي");
  const cashId = cashMethod ? cashMethod.id : null;
  const isCash = form.paymentMethodId === cashId;
  const isNonCash = form.paymentMethodId !== cashId;

  return (
    <div className="relative">
      {isSaving && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-white/70 backdrop-blur-[2px]">
          <div className="flex flex-col items-center gap-3 rounded-2xl bg-white px-8 py-6 shadow-xl border border-slate-200">
            <div className="h-12 w-12 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin" />
            <div className="text-sm font-extrabold text-blue-900">جاري حفظ الفاتورة، يرجى الانتظار...</div>
          </div>
        </div>
      )}
    <Card dir="rtl" className="max-w-4xl mx-auto mt-6 shadow-md">
      <CardContent>
        <div className="flex justify-between bg-blue-600 text-white p-2 rounded">
          <h2 className="text-base font-semibold">
            {viewMode
              ? "عرض فاتورة"
              : editingId
              ? "تعديل فاتورة"
              : "فاتورة جديدة"}
          </h2>
          {editingId && <span className="opacity-75"># {editingId}</span>}
        </div>

        {editingId && isApproved && (
          <div className={`mt-4 rounded-xl border px-4 py-3 text-sm font-bold ${isZatcaLocked ? "border-red-200 bg-red-50 text-red-800" : "border-blue-200 bg-blue-50 text-blue-700"}`}>
            {isZatcaLocked
              ? "هذه الفاتورة معتمدة وربط زاتكا مفعل، لذلك لا يمكن تعديلها أو إلغاء اعتمادها."
              : "هذه الفاتورة معتمدة. لإجراء التعديل، قم أولًا بإلغاء الاعتماد لإرجاعها إلى مسودة."}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6 text-xs mt-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-2">
            <div className="col-span-full">
              <h3 className="font-semibold text-sm mb-2 text-gray-700">
                بيانات الفاتورة الأساسية
              </h3>
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                نوع الفاتورة
              </label>
              <Input
                readOnly
                value={
                  types.find((t) => t.invoiceTypeId === form.invoiceTypeId)
                    ?.name || ""
                }
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                رقم الفاتورة
              </label>
              <Input
                readOnly
                value={form.invoiceNumber}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                تاريخ الفاتورة
              </label>
              <Input
                readOnly={viewMode}
                type="datetime-local"
                name="issueDate"
                value={form.issueDate}
                onChange={handleChange}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                رقم المرجع
              </label>
              <Input
                name="referenceNumber"
                value={form.referenceNumber}
                onChange={handleChange}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                readOnly={viewMode}
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                تاريخ المرجع
              </label>
              <Input
                name="referenceDate"
                type="datetime-local"
                value={form.referenceDate}
                onChange={handleChange}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                readOnly={viewMode}
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                المورد
              </label>
              <select
                name="supplierId"
                value={form.supplierId}
                onChange={handleChange}
                className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                disabled={viewMode}
              >
                <option value={0}>اختر مورد...</option>
                {customers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
            {form.supplierId !== 0 && (
              <div>
                <label className="block mb-1 font-medium text-gray-700">
                  رصيد المورد السابق
                </label>
                <Input
                  readOnly
                  value={form.customerPrevBalance.toFixed(decimalPlaces)}
                  className="w-full bg-gray-100 text-xs py-1.5 px-2 rounded-md border border-gray-300"
                />
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                المخزن
              </label>
              <select
                name="stockId"
                value={form.stockId}
                onChange={handleChange}
                className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                disabled={viewMode || !!restrictedStockId}
              >
                <option value={0}>اختر مخزن...</option>
                {stocks
                    .filter(s => {
                        if (restrictedStockId) return s.id === restrictedStockId;
                        if (allowedStockIds.length > 0) return allowedStockIds.includes(s.id);
                        return true;
                    })
                    .map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                ملاحظات
              </label>
              <Input
                name="notes"
                value={form.notes}
                onChange={handleChange}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                readOnly={viewMode}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                طريقة الدفع
              </label>
              <select
                name="paymentMethodId"
                value={form.paymentMethodId}
                onChange={handleChange}
                className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                disabled={viewMode}
              >
                <option value={0}>اختر طريقة دفع...</option>
                {methods.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.nameAr}
                  </option>
                ))}
              </select>
            </div>
            {isCash && (
              <div>
                <label className="block mb-1 font-medium text-gray-700">
                  الصندوق
                </label>
                <select
                  name="safeId"
                  value={form.safeId}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  disabled={viewMode || !!restrictedSafeId}
                >
                  <option value={0}>اختر صندوق...</option>
                  {safes
                    .filter(s => {
                        if (restrictedSafeId) return s.safeId === restrictedSafeId;
                        if (allowedSafeIds.length > 0) return allowedSafeIds.includes(s.safeId);
                        return true;
                    })
                    .map((s) => (
                    <option key={s.safeId} value={s.safeId}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {isNonCash && (
              <div>
                <label className="block mb-1 font-medium text-gray-700">
                  البنك
                </label>
                <select
                  name="bankId"
                  value={form.bankId}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  disabled={viewMode}
                >
                  <option value={0}>اختر بنك...</option>
                  {banks.map((b) => (
                    <option key={b.id} value={b.id}>
                      {b.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                خصم الفاتورة
              </label>
              <Input
                type="number"
                step={stepValue}
                name="discount"
                value={form.discount}
                onChange={handleChange}
                className="w-full bg-gray-50 text-xs py-1.5 px-2 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                readOnly={viewMode}
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                حالة الفاتورة
              </label>
              <select
                name="invoiceStatus"
                value={form.invoiceStatus}
                onChange={handleChange}
                className="w-full border rounded-md px-2 py-1.5 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                disabled={viewMode}
              >
                <option value={0}>مسودة</option>
                <option value={1}>معتمدة</option>
                <option value={2}>مدفوعة</option>
              </select>
            </div>
          </div>

          {!viewMode && (
            <Button
              type="button"
              className="text-xs px-3 py-1 mt-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
              onClick={handleAddLine}
            >
              ➕ إضافة سجل صنف
            </Button>
          )}

          <div className="overflow-x-auto mt-4">
            <table className="min-w-full table-auto text-xs border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  {[
                    "#",
                    "الصنف",
                    "وحدة",
                    "كمية",
                    "سعر",
                    "مجموع",
                    "خصم",
                    "ضريبة %",
                    "صافي",
                    !viewMode && "حذف",
                  ].map((h, i) =>
                    h ? (
                      <th key={i} className="px-2 py-1 border text-center">
                        {h}
                      </th>
                    ) : null
                  )}
                </tr>
              </thead>
              <tbody>
                {form.lines.map((ln, i) => {
                  const qty = parseFloat(ln.qty);
                  const price = parseFloat(ln.price); // السعر المدخل في الواجهة
                  const discount = parseFloat(ln.discount);
                  const taxRate = parseFloat(ln.taxRate);

                  // 💡 النقطة الحرجة: حسابات القيم المعروضة في الجدول بناءً على إعدادات الضريبة
                  let lineTotalBeforeDiscountDisplay = qty * price; // "مجموع" السطر كما يراه العميل (بما في ذلك الضريبة إذا كانت السعر شامل)
                  let lineAfterLineDiscountDisplay = lineTotalBeforeDiscountDisplay - discount; // القيمة بعد خصم السطر (الصافي الظاهر قبل تفكيك الضريبة)

                  let taxableAmountPerLine = lineAfterLineDiscountDisplay; // القيمة التي ستُحسب عليها الضريبة داخلياً
                  let vatAmountPerLine = 0;

                  if (settings.isPriceIncludesVAT) {
                    // إذا كان السعر يشمل الضريبة، فإن lineAfterLineDiscountDisplay هو السعر الإجمالي بعد الخصم
                    // يجب استخلاص المبلغ الخاضع للضريبة (قبل الضريبة) منه
                    taxableAmountPerLine = lineAfterLineDiscountDisplay / (1 + taxRate);
                    vatAmountPerLine = lineAfterLineDiscountDisplay - taxableAmountPerLine;
                  } else {
                    // إذا كان السعر لا يشمل الضريبة، فإن lineAfterLineDiscountDisplay هو المبلغ الخاضع للضريبة
                    vatAmountPerLine = lineAfterLineDiscountDisplay * taxRate;
                  }
                  
                  // "صافي" السطر هو القيمة النهائية التي يراها العميل بعد الخصم والضريبة
                  // عندما يكون السعر شامل الضريبة، فإن الصافي هو ببساطة (السعر * الكمية) - الخصم
                  // وعندما يكون السعر غير شامل الضريبة، فإن الصافي هو (السعر * الكمية - الخصم) + الضريبة
                  const lineNet = settings.isPriceIncludesVAT 
                    ? lineAfterLineDiscountDisplay // إذا السعر شامل، فالصافي هو ما تبقى بعد الخصم
                    : lineAfterLineDiscountDisplay + vatAmountPerLine; // إذا السعر غير شامل، فالصافي = ما تبقى بعد الخصم + الضريبة


                  return (
                    <tr key={i} className="hover:bg-gray-50">
                      
                      <td className="px-2 py-1 border text-center align-middle">
                        {i + 1}
                      </td>
                      <td className="px-2 py-1 border align-middle">
  <input
    type="text"
    className={`w-full border rounded-md px-1 py-1 text-xs 
    ${form.lines[i].hasStockError ? "bg-red-100 border-red-400 text-red-800" : "bg-white border-gray-300"} 
    focus:outline-none focus:ring-1 focus:ring-blue-500`}
    placeholder="ابحث عن صنف..."
    value={form.lines[i].productName}
    onChange={(e) => {
      const value = e.target.value;
      handleLineChange(i, "productName", value); // تحديث الاسم فقط
      setProductSearch(value);
    }}
    list={`product-options-${i}`}
    disabled={viewMode}
  />
  <datalist id={`product-options-${i}`}>
    {products
      .filter((p) =>
        p.arabicName.toLowerCase().includes(productSearch.toLowerCase())
      )
      .map((p) => (
        <option key={p.id} value={p.arabicName} />
      ))}
  </datalist>
</td>
                      <td className="px-2 py-1 border text-center align-middle">
                        <select
                          value={ln.unitId}
                          onChange={(e) =>
                            handleLineChange(i, "unitId", e.target.value)
                          }
                          className="w-full border rounded-md px-1 py-1 text-xs bg-gray-50 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                          disabled={viewMode}
                        >
                          <option value={0}>—</option>
                          {ln.unitsList.map((u) => (
                            <option key={u.unitId} value={u.unitId}>
                              {u.unitNameAr}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="px-2 py-1 border text-center align-middle">
                        <Input
                          type="number"
                          step={stepValue}
                          min="0"
                          value={ln.qty}
                          onChange={(e) =>
                            handleLineChange(i, "qty", e.target.value)
                          }
                          className="w-20 bg-gray-50 text-xs py-1 px-1 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500 text-right"
                          readOnly={viewMode}
                        />
                      </td>
                      <td className="px-2 py-1 border text-right align-middle">
                        <Input
                          type="number"
                          step={stepValue}
                          value={ln.price}
                          onChange={(e) =>
                            handleLineChange(i, "price", e.target.value)
                          }
                          className="w-24 bg-gray-50 text-xs py-1 px-1 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500 text-right"
                          readOnly={viewMode}
                        />
                      </td>
                      <td className="px-2 py-1 border text-right font-semibold align-middle">
                        {/* "مجموع" السطر كما يراه العميل (كمية * سعر مدخل) */}
                        {lineTotalBeforeDiscountDisplay.toFixed(decimalPlaces)}
                      </td>
                      <td className="px-2 py-1 border text-right align-middle">
                        <Input
                          type="number"
                          step={stepValue}
                          value={ln.discount}
                          onChange={(e) =>
                            handleLineChange(i, "discount", e.target.value)
                          }
                          className="w-24 bg-gray-50 text-xs py-1 px-1 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500 text-right"
                          readOnly={viewMode}
                        />
                      </td>
                      <td className="px-2 py-1 border text-center align-middle">
                        <div className="flex items-center justify-end">
                          <Input
                            type="number"
                            step={stepValue}
                            value={(parseFloat(ln.taxRate) * 100).toFixed(decimalPlaces)}
                            onChange={(e) =>
                              handleLineChange(
                                i,
                                "taxRate",
                                parseFloat(e.target.value) / 100
                              )
                            }
                            className="w-16 bg-gray-50 text-xs py-1 px-1 rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500 text-right inline-block"
                            readOnly={viewMode}
                          />
                          <span className="ml-1">%</span>
                        </div>
                      </td>
                      <td className="px-2 py-1 border text-right font-bold align-middle">
                        {lineNet.toFixed(decimalPlaces)}
                      </td>
                      {!viewMode && (
                        <td className="px-2 py-1 border text-center align-middle">
                          <Button
                            variant="outline"
                            size="icon"
                            className="text-xs p-1 h-auto w-auto bg-red-100 hover:bg-red-200 text-red-600 rounded-md"
                            onClick={() => handleRemoveLine(i)}
                          >
                            🗑️
                          </Button>
                        </td>
                      )}
                    </tr>
                  );
                })}
                {form.lines.length === 0 && (
                  <tr>
                    <td
                      colSpan={viewMode ? 9 : 10}
                      className="py-4 text-center text-gray-500 text-sm"
                    >
                      لا توجد سطور بعد. اضغط "إضافة سجل صنف" لإضافة أصناف.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Summary (المجاميع)*/}
          <div className="mt-6 p-4 bg-gray-50 border rounded-md text-sm">
            <div className="grid grid-cols-2 gap-2 max-w-sm ml-auto">
              <div className="text-right font-medium text-gray-700">
                المجموع:
              </div>
              <div className="text-left font-bold text-gray-900">
                {totals.subtotal.toFixed(decimalPlaces)}
              </div>

              <div className="text-right font-medium text-gray-700">
                خصم الفاتورة:
              </div>
              <div className="text-left font-bold text-gray-900">
                {totals.totalDiscount.toFixed(decimalPlaces)}
              </div>

              <div className="text-right font-medium text-gray-700">
                بعد الخصم:
              </div>
              <div className="text-left font-bold text-gray-900">
                {totals.totalAfterDiscount.toFixed(decimalPlaces)}
              </div>

              <div className="text-right font-medium text-gray-700">
                ضريبة القيمة المضافة:
              </div>
              <div className="text-left font-bold text-gray-900">
                {totals.totalVAT.toFixed(decimalPlaces)}
              </div>

              <div className="flex justify-between items-center bg-blue-500 text-white p-2 rounded-md shadow-md col-span-full sm:col-span-2 md:col-span-1">
                <strong className="text-base">الصافي:</strong>
                <span className="text-base font-extrabold">
                  {totals.net.toFixed(decimalPlaces)}
                </span>
              </div>
            </div>
          </div>

          {/* Actions (الإجراءات) */}
          <div className="flex justify-end gap-3 mt-6">
            {!viewMode && !isApproved && (
              <Button
                type="submit"
                disabled={isSaving}
                className="text-sm px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md"
              >
                💾 حفظ الفاتورة
              </Button>
            )}
            {editingId && showApproveButton && !isApproved && (
  <Button
    size="sm"
    disabled={isSaving}
    className="bg-green-600 hover:bg-green-700 text-white"
    onClick={handleApprove}
  >
    ✅ اعتماد الفاتورة
  </Button>
)}
{editingId && isApproved && canUnapprove && (
  <Button
    size="sm"
    disabled={isSaving}
    className="bg-amber-500 hover:bg-amber-600 text-white"
    onClick={handleUnapprove}
  >
    ↩️ إلغاء الاعتماد
  </Button>
)}

            {form.journalEntryGlobalId && (
              <Button 
                type="button" 
                variant="outline" 
                className="text-sm px-4 py-2 bg-purple-100 hover:bg-purple-200 text-purple-800 rounded-md border border-purple-300"
                onClick={() => window.open(`/journal-entries/${form.journalEntryGlobalId}/view`, "_blank")}
              >
                👁️ عرض القيد
              </Button>
            )}

            <Button
              variant="outline"
              className="text-sm px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md border border-gray-300"
              onClick={() => navigate("/reports/all-invoices")}
            >
              ↩️ رجوع للقائمة
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
    </div>
  );
  
}
